module.exports = __webpack_public_path__ + "static/media/TheBreakupListsBookCover.bc9aa1f4.jpg";